import React, { useState,useEffect } from "react";
import InputField from '@src/common/InputField';
import ReactSelect from '@src/common/ReactSelect';
import DatePicker from "react-datepicker";
import { getAgencyDetails,getSfaRoleUserList,updateAgencyData,approveAgency,deleteAgencyDocumentFile } from '@src/store/slices/agency';
import ConfirmPopUp from '@src/common/ConfirmPopUp';
import RejectReasonPopup from '@src/common/RejectReasonPopup';
import { useSelector,useDispatch } from 'react-redux';
import { bankList,getMasterConfig,getDocUploadUrl, getCityList, getLocalityList } from '@src/store/slices/common';
import FullPageLoader from '@src/common/FullPageLoader';
import InsIdUploadDocuments from './InsIdUploadDocuments';
import { useParams } from 'react-router-dom';
import {DOC_ID, REGEX_EMAIL_VALIDATION,STATUS_SUCCESS,VP_ID} from '@src/config/constant';
import { toast } from "react-toastify";
import { useLanguage } from "@src/context/LanguageContext";
import { formatNPWP } from '@src/config/helper';
import { useNavigate } from 'react-router-dom';



function AddEditInsuranceIdAgency(props: any): ReturnType<React.FC> {
    const queryParams = useParams();
    const {translations} = useLanguage();
    const dispatch: any = useDispatch();
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [actionType, setActionType] = useState<any>('');
    const [showRejectReason, setShowRejectReason] = useState(false);
    const [confirmationMessage, setConfirmationMessage] = useState('');
    let [agencyBanksLists, setAgencyBanksList] = useState<any>([]);
    let [martialStatusOptions, setMartialStatusOptions] = useState<any>([]);
    // let [genderOptions, setGenderOptions] = useState<any>([]);
    let [cityList, setCityList] = useState<any>([]);
    const commonState = useSelector((state: any) => state.common);
    const [loading, setLoading] = useState(false);
    const [editForm, setEditForm] = useState(false);
    const [disableField, setDisableField] = useState(true);
    const [roleList, setRoleList] = useState<any>([]);
    const [reportingToRole, setReportingToRole] = useState<any>([]);
    const [reportingTo, setReportingTo] = useState<any>([]);
    const [districts, setDistricts] = useState<any>([]);
    const [rejectReason, setRejectReason] = useState<any>([]);
    const [agencyStatus, setAgencyStatus] = useState();
    const [roleId, setRoleId] = useState(0);
    let [errors, setErrors] = useState<any>({})
    const navigate = useNavigate();

    let initialInputState = {
        userDetails: {
            agency_name: '',
            email: '',  
            mobile: '',    
            referral_code: '',
        },
        personalDetails: {
            ktp_id: '',      
            npwp_no: '',       
            marital_status: '', 
            gender: '',         
            dob: '',           
            city_of_birth: '', 
        },
        ktpAddressDetails: {
            housing: '',        
            rt: '',             
            rw: '',                    
            city: '',           
            district: '',      
            sub_district: '',  
        },
        bankDetails: {
            bank_name: '',    
            account_no: '',   
            beneficiary_name: '', 
            branch_name: '',
        },
        roleDetails:{
            user_role : '',
            reporting_to_role :'',
            reporting_to : ''
        }
    };
    let [selectedInput, setSelectedInput] = useState<any>(initialInputState)
    const [documents, setDocumets] = useState<any>([
        { label: "Upload KTP ID" , doc_id: DOC_ID.KTP},
        { label: "Selfie with KTP (optional)",doc_id: DOC_ID.SELFIE_WITH_KTP },
        { label: "NPWP (optional)",doc_id: DOC_ID.NPWP },
    ])
    const [bankDocuments, setBankDocuments] = useState<any>([
        { label: "Bank Statement 1", doc_id: DOC_ID.BANK_STATEMENT },
        { label: "Bank Statement 2" ,doc_id: DOC_ID.BANK_STATEMENT },
    ])
    const [apiDocs, setApiDocs] = useState<any>([]);
    const [bankDocs, setBankDocs] = useState<any>([]);
    const [deletedApiDocs, setDeletedApiDocs] = useState<any>([]);
    const [deletedBankDocs, setDeletedBankDocs] = useState<any>([]);
    const agency_id = queryParams.id
    
    useEffect(() => {
        if (agency_id !== undefined) {
            // Fetch or do something with the agency ID
            fetchAgencyDetails(agency_id);
        }// eslint-disable-next-line
        else{
            setDisableField(!disableField);
            setEditForm(!editForm)
        }
        // eslint-disable-next-line
    }, [agency_id]);

    useEffect(() => {
        if (!commonState?.agencyBankList?.length) {
            dispatch(bankList()).then((res: any) => {
                if (res && res.status === STATUS_SUCCESS) {
                    setAgencyBanksList((prev: any) => [...prev, ...res.data]);
                }
            })
        } else {
            setAgencyBanksList(commonState?.agencyBankList);
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!commonState?.cityList?.length) {
            dispatch(getCityList({ state: [] })).then((res: any) => {
                if (res && res.status === STATUS_SUCCESS) {
                    setCityList((prev: any) => [...prev, ...res.data]);
                }
            })
        } else {
            setAgencyBanksList(commonState?.cityList);
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!commonState?.sfa_roles?.length) {
            dispatch(getMasterConfig()).then((res: any) => {
                if (res && res.status === STATUS_SUCCESS) {
                    setRoleList(res.data.sfa_roles);
                    const transformedRoles = res.data.sfa_roles.map((role: any) => ({
                        ...role,
                        label: role.description 
                    }));
                    setReportingToRole(transformedRoles);
                    
                    // setGenderOptions(res.data.gender) 
                    setMartialStatusOptions(res.data.marital_status)
                    
                }
            })
        } else {
            setRoleList(commonState?.sfa_roles);
            setReportingToRole(commonState?.sfa_roles);
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        dispatch(getMasterConfig()).then((res: any) => {
            if (res && res.status === STATUS_SUCCESS) {
                setRejectReason(res.data.reject_reason_list);
            }
        })// eslint-disable-next-line
    },[])

    const fetchAgencyDetails = (id:any) => {
        setLoading(true)
        setEditForm(false)
        getAgencyDetails({user_id:id}).then((res: any) => {
            setLoading(false)
            if (res.status === STATUS_SUCCESS) {
                setDisableField(true);
                populateInputState(res.data);
            }
        }).catch(err => setLoading(false))
    }

    const populateInputState = (data:any) => {
        if(data.personal_detail?.city){
            fetchDistrictList({value:data.personal_detail?.city},false)
        }
        setAgencyStatus(data.status ?? 2);
        setRoleId(data.role_id);
        setSelectedInput({
            userDetails: {
                agency_name: data.name || '',
                email: data.email || '',
                mobile: data.mobile || '',
                referral_code: data.referral || '',
            },
            personalDetails: {
                ktp_id: data.personal_detail?.ktp_id || '',
                npwp_no: data.personal_detail?.npwp_no || '',
                marital_status: data.personal_detail?.marital_status || '',
                gender: data.personal_detail?.gender || '',
                dob: data.personal_detail?.dob || '',
                city_of_birth: data.personal_detail?.city_birth || '',
            },
            ktpAddressDetails: {
                housing: data.personal_detail?.housing || '',
                rt: data.personal_detail?.rt || '',
                rw: data.personal_detail?.rw || '',
                city: data.personal_detail?.city || '',
                district: data.personal_detail?.district || '',
                sub_district: data.personal_detail?.sub_district || '',
            },
            bankDetails: {
                bank_name: data.bank_detail?.bank_id || '',
                account_no: data.bank_detail?.account_no || '',
                beneficiary_name: data.bank_detail?.account_name || '',
                branch_name: data.bank_detail?.branch_name || '',
            },
            roleDetails: {
                user_role: data.role_id || '',
                reporting_to_role: data?.role_detail?.manager_role_id || '',
                reporting_to: data?.role_detail?.manager_id || '',
            },
        });
        if(data.role_id){
            let role_id:number;
            if(+data.role_id === 1){
                role_id = +data.role_id
            }else{
                role_id = +(data.role_id-1)
            }
            getSfaRoleUser({role_id : role_id},false)
        }
        const docNames = [
            "Upload KTP ID",
            "Selfie with KTP (optional)",
            "NPWP (optional)"
        ];
        
        const fetchedApiDocs = docNames.map((docName, index) => {
            const doc = data.docs.find((d: any) => d.doc_name === docName);
            if (doc) {
                return {
                    id: doc.id || index + 1,
                    doc_id: doc.doc_id ?? index + 1, 
                    label: docName,
                    url: doc.doc_path || "",
                    doc_file_type:doc.doc_file_type

                };
            }
            return null;
        }).filter(Boolean);

        const fetchedBankDocs: any = data.bank_detail?.bank_statement_url.map((url:any, key:number) => ({
            id : url.id,
            doc_id : key + 1,
            url: url.doc_path,
            label: `Bank Statement ${key + 1}`,
            doc_file_type:url.doc_file_type
        }));
        
        // Update documents with the correct doc_id
        const updatedDocuments = documents.map((doc: any, index:number) => {
            const matchingDoc = fetchedApiDocs.find((apiDoc: any) => apiDoc.label === doc.label);
            return matchingDoc
            ? {
                ...doc,
                doc_id: matchingDoc.doc_id ?? index+1,
                url: matchingDoc.url,
                doc_file_type:matchingDoc.doc_file_type

                }
            : doc;
        });
        
        // Update bankDocuments with the correct doc_id
        const updatedBankDocuments = bankDocuments.map((doc: any) => {
            const matchingDoc = fetchedBankDocs.find((bankDoc: any) => bankDoc.label === doc.label);
            return matchingDoc
            ? {
                ...doc,
                doc_id: matchingDoc.doc_id,
                url: matchingDoc.url,
                doc_file_type:matchingDoc.doc_file_type
                }
            : doc;
            
        });
        setDocumets(updatedDocuments);
        setBankDocuments(updatedBankDocuments);
        setApiDocs(fetchedApiDocs);
        setBankDocs(fetchedBankDocs);
    }

    const checkAgencyApprovedOrNot = (params: any) => {
        if(roleId===0) return toast.error(translations.RuleEngineAgency?.['Please_Assign_role_first'] || translations.commonMsg?.loading);
        agencyProcess(params);
    }

    const agencyProcess = (type: any) => {
        setShowConfirmation(true);
        setActionType(type);
        setConfirmationMessage(`${translations.RuleEngineAgency?.['Are_you_sure_you_want_to'] || translations.commonMsg?.loading} ${type} ${selectedInput.userDetails.agency_name} ?`);
    }

    const confirmNo = () => {
        setShowConfirmation(false);
        setActionType(null);
    }

    const rejectNo = () => {
        setShowRejectReason(false);
    }

    const rejectYes = async (data: { reject_reason: string; reject_remark: string }) => {
        await approveAgency({type:actionType,agency_id:agency_id,reject_reason_id:data.reject_reason,reject_remark:data.reject_remark}).then((res: any) => {
            setLoading(false)
            if (res.status === STATUS_SUCCESS) {
                toast.success(res.message);
                fetchAgencyDetails(agency_id);
                setShowRejectReason(false);
            }
        }).catch(err => setLoading(false))
    }

    const confirmYes = async () => {
        if(actionType === "approve"){
            await approveAgency({type:actionType,agency_id:agency_id}).then((res: any) => {
                setLoading(false)
                if (res.status === STATUS_SUCCESS) {
                    toast.success(res.message);
                    fetchAgencyDetails(agency_id);
                    setShowConfirmation(false);
                }
            }).catch(err => setLoading(false))
        }else{
            setShowConfirmation(false);
        }
    }

    const handleEdit = () => {
        if(editForm){
            saveData();
        }else{
            setDisableField(!disableField);
            setEditForm(!editForm)
        }
    }

    const checkValidation = (): boolean => {
        let error = false
        setErrors({})          
        if (!selectedInput.userDetails.agency_name.trim() || selectedInput.userDetails.agency_name.trim().length > 75) {
            errors['agency_name'] = translations.RuleEngineAgency?.['Agency_name_error_msg'] || translations.commonMsg?.loading ;
            error = true;
        }else{
            delete errors['agency_name'];
        }

        if (!selectedInput.userDetails.mobile || !/^8\d{7,12}$/.test(selectedInput.userDetails.mobile)) {
            errors['mobile'] = translations.RuleEngineAgency?.['Agency_mobile_error_msg'] || translations.commonMsg?.loading;
            error = true;
        }else{
            delete errors['mobile'] 
        }
        
        if (!selectedInput.userDetails.email.trim() || !REGEX_EMAIL_VALIDATION.test(selectedInput.userDetails.email)) {
            errors['email'] = translations.RuleEngineAgency?.['Email_error_msg'] || translations.commonMsg?.loading;
            error = true;
        }
        else{
            delete errors['email']
        }

        if (!selectedInput.personalDetails.ktp_id) {
            errors['ktp_id'] = translations.RuleEngineAgency?.['KTP_id_required_msg'] || translations.commonMsg?.loading;
            error = true;
        }
        else if(selectedInput?.personalDetails?.ktp_id.length!==16){
            errors['ktp_id'] = translations.RuleEngineAgency?.['KTP_id_length_msg'] || translations.commonMsg?.loading;
            error = true;
        }
        else{
            delete errors['ktp_id'] 
        }

        const npwpNo = selectedInput.personalDetails.npwp_no?.trim();
    
        // If npwp_no is not provided (blank), no error
        if (npwpNo && npwpNo.length > 0) {
            // Check if npwp_no matches the valid format (XX.XXX.XXX.X-XXX.XXX)
            const npwpFormat = /^\d{2}\.\d{3}\.\d{3}\.\d{1}-\d{3}\.\d{3}$/;
            if (!npwpFormat.test(npwpNo)) {
                errors['npwp_no'] = translations.RuleEngineAgency?.['NPWP_format_error_msg'] || translations.commonMsg?.loading;
                error = true;
            } else {
                delete errors['npwp_no'];
            }
        } else {
            delete errors['npwp_no']; // If npwp_no is empty, no error
        }

        // if (!selectedInput.personalDetails.marital_status) {
        //     errors['marital_status'] = translations.RuleEngineAgency?.['Marital_status_error_msg'] || translations.commonMsg?.loading;
        //     error = true;
        // }else{
        //     delete  errors['marital_status']
        // }

        if (!selectedInput.personalDetails.gender) {
            errors['gender'] = translations.RuleEngineAgency?.['Gender_required_error_msg'] || translations.commonMsg?.loading;
            error = true;
        }else{
            delete  errors['gender']
        }

        if (!selectedInput.personalDetails.dob) {
            errors['dob'] = translations.RuleEngineAgency?.['DOB_error_msg'] || translations.commonMsg?.loading;
            error = true;
        }
        else{
            delete  errors['dob']
        }

        // if (!selectedInput.personalDetails.city_of_birth) {
        //     errors['city_of_birth'] = translations.RuleEngineAgency?.['City_dob_error_msg'] || translations.commonMsg?.loading;
        //     error = true;
        // }
        // else{
        //     delete  errors['city_of_birth']
        // }
    
        // Validate ktpAddressDetails
        if (!selectedInput.ktpAddressDetails.housing.trim()) {
            errors['housing'] = translations.RuleEngineAgency?.['Housing_required_error_msg'] || translations.commonMsg?.loading;
            error = true;
        }
        else{
            delete errors['housing'];
        }

        // if (!/^\d{3}$/.test(selectedInput.ktpAddressDetails.rt)) {
        //     errors['rt'] = translations.RuleEngineAgency?.['RT_error_msg'] || translations.commonMsg?.loading;
        //     error = true;
        // }
        // else{
        //     delete errors['rt'];
        // }

        // if (!/^\d{3}$/.test(selectedInput.ktpAddressDetails.rw)) {
        //     errors['rw'] = translations.RuleEngineAgency?.['RW_error_msg'] || translations.commonMsg?.loading;
        //     error = true;
        // }
        // else{
        //     delete errors['rw'];
        // }

        if (!selectedInput.ktpAddressDetails.city) {
            errors['city'] = translations.RuleEngineAgency?.['City_required_error_msg'] || translations.commonMsg?.loading;
            error = true;
        }
        else{
            delete errors['city'];
        }

        if (!selectedInput.ktpAddressDetails.district) {
            errors['district'] = translations.RuleEngineAgency?.['District_required_error_msg'] || translations.commonMsg?.loading;
            error = true;
        }
        else{
            delete errors['district'];
        }

        if (!selectedInput.ktpAddressDetails.sub_district.trim()) {
            errors['sub_district'] = translations.RuleEngineAgency?.['Sub-district_required_error_msg'] || translations.commonMsg?.loading;
            error = true;
        }
        else{
            delete errors['sub_district'];
        }
    
        // Validate bankDetails
        if (!selectedInput.bankDetails.bank_name) {
            errors['bank_name'] = translations.RuleEngineAgency?.['Bank_name_required_error_msg'] || translations.commonMsg?.loading;
            error = true;
        }
        else{
            delete errors['bank_name'];
        }

        // if (!selectedInput.bankDetails.branch_name.trim()) {
        //     errors['branch_name'] = translations.RuleEngineAgency?.['Branch_name_required_error_msg'] || translations.commonMsg?.loading;
        //     error = true;
        // }
        // else{
        //     delete errors['branch_name'];
        // }

        if (!selectedInput.bankDetails.account_no || !/^\d+$/.test(selectedInput.bankDetails.account_no)) {
            errors['account_no'] = translations.RuleEngineAgency?.['Account_number_error_msg'] || translations.commonMsg?.loading;
            error = true;
        }
        else{
            delete errors['account_no'];
        }

        if (!selectedInput.bankDetails.beneficiary_name.trim()) {
            errors['beneficiary_name'] = translations.RuleEngineAgency?.['Beneficiary_name_error_msg'] || translations.commonMsg?.loading;
            error = true;
        }
        else{
            delete errors['beneficiary_name'];
        }

        // Validate Role Detail   
        if (!selectedInput.roleDetails.user_role) {
            errors['user_role'] = translations.RuleEngineAgency?.['User_role_error_msg'] || translations.commonMsg?.loading;
            error = true;
        }
        else{
            delete errors['user_role'];
        }

        if (!selectedInput.roleDetails.reporting_to_role && selectedInput.roleDetails.user_role !== VP_ID) {
            errors['reporting_to_role'] = translations.RuleEngineAgency?.['Reporting_to_role_required_error_msg'] || translations.commonMsg?.loading;
            error = true;
        }
        else{
            delete errors['reporting_to_role'];
        }

        if (!selectedInput.roleDetails.reporting_to && selectedInput.roleDetails.user_role !== VP_ID) {
            errors['reporting_to'] = translations.RuleEngineAgency?.['Reporting_to_required'] || translations.commonMsg?.loading;
            error = true;
        }
        else{
            delete errors['reporting_to'];
        }

        const requiredApiDoc = apiDocs.find((doc:any) => doc.label === "Upload KTP ID");
        
        if (!requiredApiDoc || requiredApiDoc.url === "") {
            errors['apiDocs'] = translations.RuleEngineAgency?.['Upload_KTP_ID_required'] || translations.commonMsg?.loading;
            error = true;
        }
        else{
            delete errors['apiDocs'];
        }

        if (!bankDocs || bankDocs.length === 0) {
            errors['bankDocs'] = translations.RuleEngineAgency?.['bank_doc_least_error_msg'] || translations.commonMsg?.loading;
            error = true;
        } else if (bankDocs.length > 2) {
            errors['bankDocs'] = translations.RuleEngineAgency?.['bank_doc_max_error_msg'] || translations.commonMsg?.loading;
            error = true;
        }
        else{
            delete errors['bankDocs'];
        }
        setErrors({ ...errors });
        return error
    }

    const saveData = async () => {
        try{
            setLoading(true)
            let errorExists = checkValidation()
            if (!errorExists) {
                setErrors({});
                const documents = await updateDocsWithUrls(apiDocs);
                const bank_statement_url = await updateDocsWithUrls(bankDocs, true);
                if(!fileUploadErr){
                    const dataToSave = {
                        // "user_id": agency_id,
                        "name": selectedInput.userDetails.agency_name,
                        "email": selectedInput.userDetails.email,
                        "mobile": selectedInput.userDetails.mobile,
                        "referral": selectedInput.userDetails.referral_code ?? null,
                        "ktp_id": selectedInput.personalDetails.ktp_id,
                        "npwp_no": selectedInput.personalDetails.npwp_no,
                        "marital_status": selectedInput.personalDetails.marital_status || null,
                        "gender": selectedInput.personalDetails.gender,
                        "dob": selectedInput.personalDetails.dob,
                        "city_birth": selectedInput.personalDetails.city_of_birth || null,
                        "housing": selectedInput.ktpAddressDetails.housing,
                        "rt": selectedInput.ktpAddressDetails.rt || "",
                        "rw": selectedInput.ktpAddressDetails.rw || "",
                        "city": selectedInput.ktpAddressDetails.city,
                        "district": selectedInput.ktpAddressDetails.district,
                        "sub_district": selectedInput.ktpAddressDetails.sub_district,
                        "bank_id": selectedInput.bankDetails.bank_name,
                        "branch_name": selectedInput.bankDetails.branch_name || "",
                        "account_no": selectedInput.bankDetails.account_no,
                        "beneficiary_name": selectedInput.bankDetails.beneficiary_name,
                        "documents": documents,
                        "bank_statement_url" : bank_statement_url,
                       // "update_from": "web",
                        ...(selectedInput.roleDetails.user_role && { sfa_role_id: selectedInput.roleDetails.user_role }),
                        ...(selectedInput.roleDetails.reporting_to_role && { reporting_to_role: selectedInput.roleDetails.reporting_to_role }),
                        ...(selectedInput.roleDetails.reporting_to && { reporting_to: selectedInput.roleDetails.reporting_to })
                    };

                    if(agency_id !== undefined){
                        dataToSave['user_id'] = agency_id;
                        dataToSave['update_from'] = "web";
                    }else{
                        dataToSave['source'] = "web";
                        dataToSave['add_from'] = "web";
                    }
                    const res:any = await updateAgencyData(dataToSave);
                    if (res.status === STATUS_SUCCESS) {
                        if(agency_id !== undefined){
                            const deleteDocReq = {
                                agency_id:agency_id,
                                bank_statement_url:deletedBankDocs,
                                docs:deletedApiDocs
                            }
                            await deleteAgencyDocumentFile(deleteDocReq);
                            toast.success(res.message);
                            setLoading(false);
                            fetchAgencyDetails(agency_id);
                            setEditForm(false);
                            setDisableField(true);
                        }else{
                            navigate('/agency-list');
                        }
                    }
                }

                
            }else{
                setLoading(false)
            }
        }catch (err) {
            setLoading(false)
        }finally {
            setLoading(false);
        }
    }

    let fileUploadErr = false;

    const updateDocsWithUrls = async (apiDocs: any[], isBankStatement = false) => {
        try {
            const documentsToUpload = apiDocs.filter((doc) => doc.file);
        
            if (documentsToUpload.length === 0) {
                return []; // Return an empty array if no documents need to be uploaded
            }
    
            const updatedDocs:any = [];
            for (const doc of documentsToUpload) {
                const formData = new FormData();
                formData.append("upload_type", "insurance_docs");
                formData.append("upload_doc_type", "insurance_docs");
                formData.append("lead_id", "register-user");
                formData.append("files", doc.file);
    
                try {
                    const response: any = await getDocUploadUrl(formData);
    
                    if (response.status === STATUS_SUCCESS && response.data && response.data[0]) {
                        const uploadedFile = response.data[0];
    
                        if (isBankStatement) {
                            updatedDocs.push(uploadedFile.file_name);
                        } else {
                            updatedDocs.push({
                                doc_id : doc.doc_id,
                                doc_path: uploadedFile.file_name,
                            });
                        }
                        // delete doc.file;
                        // delete doc.label;
                    } else {
                        fileUploadErr = true;
                        console.error(translations.RuleEngineAgency?.['upload_error_msg'] || translations.commonMsg?.loading , doc.label);
                    }
                } catch (error) {
                    fileUploadErr = true;
                    console.error(translations.RuleEngineAgency?.['upload_doc_error_msg'] || translations.commonMsg?.loading, doc.label, error);
                }
            }
            return updatedDocs;
        } catch (error) {
            console.error(translations.RuleEngineAgency?.['updating_doc_error_msg'] || translations.commonMsg?.loading, error);
            return []; // Return an empty array in case of an error
        }
    };
    
      

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value, type } = e.target;
    
        // Check if the target is a checkbox or radio input
        const isCheckboxOrRadio = type === "checkbox" || type === "radio";
        const newValue = isCheckboxOrRadio ? value : value;
    
        // Traverse the nested state using keys in 'name'
        const keys = name.split(".");
    
        setSelectedInput((prevState: any) => {
            const updatedState = { ...prevState };
    
            let pointer = updatedState;
    
            // Traverse to the nested object and update the value at the correct path
            keys.slice(0, -1).forEach((key) => {
                if (!pointer[key]) {
                    pointer[key] = {}; // Ensure nested objects are created if not exist
                }
                pointer = pointer[key];
            });
    
            // Get the final key from the keys array
            const finalKey = keys[keys.length - 1];
    
            if (finalKey === "npwp_no") {
                // If the new value's length is shorter than the previous value's length (backspace), skip formatting
                if (newValue.length < pointer[finalKey]?.length) {
                    pointer[finalKey] = newValue;
                } else {
                    // Apply the format when the length increases
                    pointer[finalKey] = formatNPWP(newValue);
                }
            } else if (finalKey === "rt" || finalKey === "rw") {
                // Allow only up to 2 digits
                if (newValue.length <= 3) {
                    pointer[finalKey] = newValue;
                } else {
                    // Keep previous value if user tries to exceed 2 digits
                    pointer[finalKey] = pointer[finalKey] || "";
                }
            } else {
                pointer[finalKey] = newValue;
            }
    
            return updatedState;
        });
    
        // Remove error for the field on user input
        setErrors((prevErrors: any) => {
            const e = { ...prevErrors };
            delete e[name.split('.').pop()!];
            return e;
        });
        //checkValidation();
    };
    

    

    const getSfaRoleUser = (params : any,isLoading = true) => {
        if(isLoading){
            setLoading(true)
            setEditForm(true)
        }
        getSfaRoleUserList(params).then((res: any) => {
            setLoading(false)
            if (res.status === STATUS_SUCCESS) {
                if(isLoading){
                    setDisableField(false);
                }
                setReportingTo(res.data);
                if(isLoading){
                    setSelectedInput((prevState: any) => {
                        const updatedState = { ...prevState };
                        updatedState.roleDetails.reporting_to = '';
                        return updatedState;
                    });
                }
            }
        }).catch(err => setLoading(false))
    }

    const fetchDistrictList = async (params:any,showLoader = true) => {
        if(showLoader){
            setLoading(true)
        }

        try {
            const res = await dispatch(getLocalityList({ city: [params.value] }))
            if (res?.status === STATUS_SUCCESS) {
                setDistricts(res.data);
            }
        } finally {
            setLoading(false)
        }

        // dispatch(getDistrictList({city : [params.value]})).then((res: any) => {
        //     setLoading(false)
        //     if (res.status === STATUS_SUCCESS) {
        //         setDistricts(res.data);
        //     }
        // }).catch((err: any) => setLoading(false))
    }
    
    const handleDropdownChange = (selectedOption: any, name: string) => {
        if(name === "roleDetails.user_role"){
            let role_id:number;
            if(+selectedOption.value === 1){
                role_id = +selectedOption.value
            }else{
                role_id = +(selectedOption.value-1)
            }
            getSfaRoleUser({role_id : role_id})
        }
        if(name === "ktpAddressDetails.city"){
            fetchDistrictList(selectedOption);
        }
        setSelectedInput((prevState: any) => {
            const keys = name.split(".");
            const updatedState = { ...prevState };
            let pointer = updatedState;

            // Traverse to the nested object
            for (let i = 0; i < keys.length - 1; i++) {
                pointer = pointer[keys[i]];
            }

            // Update the final key
            pointer[keys[keys.length - 1]] = selectedOption?.value;

            if (name === "roleDetails.user_role") {
                updatedState.roleDetails.reporting_to_role = selectedOption?.value === 1 ? selectedOption?.value : (selectedOption?.value - 1);
            }
            if(updatedState){
                checkValidation();
            }
            return updatedState;
        });
    };

    const handleDateChange = (date: any) => {
        const validDate = new Date(date);
        if (isNaN(validDate.getTime())) {
            console.error("Invalid Date");
            return;
        }
        const formattedDate = validDate.toISOString().split('T')[0];
        setSelectedInput((prevState : any) => ({
            ...prevState,
            personalDetails: {
                ...prevState.personalDetails,
                dob: formattedDate,
            }
        }));

        // Remove DOB error on date select
        setErrors((prevErrors: any) => {
            const e = { ...prevErrors };
            delete e.dob;
            return e;
        });
    };

    // useEffect(() => {
    //     console.log("updated selectedInput ==",selectedInput);
    // }, [selectedInput]);

    const askRejectReason = (type: any) => {
        setActionType(type);
        setShowRejectReason(true);
    }

    const handleDocumentUpload = (uploadedDocument: any, isBankStatement: boolean) => {
        if (isBankStatement) {
            setBankDocs((prev:any) => [
                ...prev,
                {
                  label: uploadedDocument.label,
                  file: uploadedDocument.file,
                },
            ]);
        } else {
            setApiDocs((prevDocs:any) => [
                ...prevDocs,
                {
                    doc_id: uploadedDocument.doc_id,
                    label: uploadedDocument.label,
                    file: uploadedDocument.file,
                },
            ]);
        }
        // remove image errors
        if (errors?.apiDocs || errors?.bankDocs) {
            const e = { ...errors };
            if (e?.apiDocs && uploadedDocument.doc_id === DOC_ID.KTP) {
                delete e.apiDocs;
            }

            if (e?.bankDocs && uploadedDocument.doc_id === DOC_ID.BANK_STATEMENT) {
                delete e.bankDocs;
            }
            setErrors(e);
        }
    };

    const handleDocumentRemove = (label: string, isBankStatement: boolean) => {
        if (label === undefined || label === null) {
            return;
        }
        let deletedDocId: number | null = null;
        if (isBankStatement) {
            const removedDoc = bankDocs.find((doc: any) => doc.label === label);
            if (removedDoc) {
                deletedDocId = removedDoc.id;
                setBankDocs((prevBankDocs: any) =>
                    prevBankDocs.filter((doc: any) => doc.label !== label)
                );
                setDeletedBankDocs((prevDeleted: any) => [...prevDeleted, deletedDocId]);
            }
        } else {
            const removedDoc = apiDocs.find((doc: any) => doc.label === label);
            if (removedDoc) {
                deletedDocId = removedDoc.id;
                setApiDocs((prevApiDocs: any) =>
                    prevApiDocs.filter((doc: any) => doc.label !== label)
                );
                setDeletedApiDocs((prevDeleted: any) => [...prevDeleted, deletedDocId]);
            }
        }


        fileUploadErr = false;


    };


    return (
        <React.Fragment>
            <FullPageLoader show={loading} />
            <div className="container-fluid">
                <div className="top-bar top-heading d-flex">
                    <h1>{translations.RuleEngineAgency?.['View_User'] || translations.commonMsg?.loading} </h1>
                    <div className="button-group action-button-group">
                        {
                            (agencyStatus === 2 || agencyStatus === 3) && 
                            <button className="btn-primary" onClick={() => { checkAgencyApprovedOrNot("approve") }}
                            disabled={loading}
                            >{translations.RuleEngineAgency?.['Approve'] || translations.commonMsg?.loading}
                            </button >
                        }
                        { 
                            agencyStatus === 2 &&
                            <button className="btn-line" onClick={() => { askRejectReason('reject') }}
                            disabled={loading}
                            >{translations.commonMsg?.['reject'] || translations.commonMsg?.loading}</button>
                        }
                    </div>
                </div>
                <div className="ins-route-files">
                    <div className=" insurance-create-outer relative " style={{ "display": "block" }}>
                        <div className="loan-expect-left-panle">
                            <div className="loan-form">
                                <div className={`agency-loan-form-filed`}>
                                    <div className="loan-filed-sec">
                                        <div className="row">
                                            <div className="col-md-12 d-flex top-bar">
                                                <h2>{translations.RuleEngineAgency?.['Upload_Documents'] || translations.commonMsg?.loading}</h2>
                                                <div className="button-group action-button-group">
                                                    <button className="btn-line" onClick={handleEdit}>
                                                        {
                                                            !editForm ? <> <i className='ic-edit m-xs-r'></i> <span>{translations.commonMsg?.['edit'] || translations.commonMsg?.loading}</span></> : <span>{translations.commonMsg?.['save'] || translations.commonMsg?.loading}</span>
                                                        }
                                                    </button>
                                                </div>
                                            </div>
                                            <InsIdUploadDocuments
                                                heading={translations.RuleEngineAgency?.['Upload_Documents'] || translations.commonMsg?.loading}
                                                documents={documents}
                                                initialDocs={apiDocs}
                                                onDocumentUpload={(uploadedDocument:any) => handleDocumentUpload(uploadedDocument, false)}
                                                onDocumentRemove={(label: string) => handleDocumentRemove(label, false)}
                                                errors={errors}
                                            />
                                        </div>
                                        <div className="row agency_basic_detail">
                                            <div className="col-md-12">
                                                <h2 className="agency-basic-detail">{translations.RuleEngine?.['Basic_Details'] || translations.commonMsg?.loading} </h2>
                                            </div>
                                            <fieldset className="col-md-3">
                                                <div className="material">
                                                    <InputField
                                                        inputProps={{
                                                            id: "full_name",
                                                            name: "userDetails.agency_name",
                                                            className: "form-input",
                                                            type: "text",
                                                            value: selectedInput.userDetails.agency_name,
                                                            disabled: disableField,
                                                        }}
                                                        onChange={handleChange}
                                                    />
                                                    <label data-label={translations.RuleEngineAgency?.['Full_Name']+' *' || translations.commonMsg?.loading} className="form-label"></label>
                                                    {
                                                        errors && errors.agency_name
                                                            ?
                                                            <span className="error-txt">{errors.agency_name}</span>
                                                            :
                                                            ''
                                                    }
                                                </div>
                                            </fieldset>
                                            <fieldset className="col-md-3">
                                                <div className="material">
                                                    <InputField
                                                        inputProps={{
                                                            id: "mobile",
                                                            name: "userDetails.mobile",
                                                            className: "form-input",
                                                            type: "text",
                                                            value: selectedInput.userDetails.mobile,
                                                            maxLength: "12",
                                                            disabled: disableField,

                                                        }}
                                                        onChange= {handleChange}
                                                    />
                                                    <label data-label={translations.RuleEngine?.['Mobile_No']+' *' || translations.commonMsg?.loading} className="form-label"></label>
                                                    {
                                                        errors && errors.mobile
                                                        ?
                                                        <span className="error-txt">{errors.mobile}</span>
                                                        :
                                                        ''
                                                    }
                                                </div>
                                            </fieldset>
                                            <fieldset className="col-md-3">
                                                <div className="material">
                                                    <InputField
                                                        inputProps={{
                                                            id: "email",
                                                            name: "userDetails.email",
                                                            className: "form-input",
                                                            type: "text",
                                                            value: selectedInput.userDetails.email,
                                                            disabled: disableField,
                                                        }}
                                                        onChange= {handleChange}
                                                    />
                                                    <label data-label={translations.RuleEngine?.['Email']+' *' || translations.commonMsg?.loading} className="form-label"></label>
                                                    {
                                                        errors && errors.email
                                                        ?
                                                        <span className="error-txt">{errors.email}</span>
                                                        :
                                                        ''
                                                    }
                                                </div>
                                            </fieldset>
                                            <fieldset className="col-md-3">
                                                <div className="material">
                                                    <InputField
                                                        inputProps={{
                                                            id: "Referral_code",
                                                            name: "userDetails.referral_code",
                                                            className: "form-input",
                                                            type: "text",
                                                            value: selectedInput.userDetails.referral_code,
                                                            disabled: disableField,
                                                        }}
                                                        onChange= {handleChange}
                                                    />
                                                    <label data-label={translations.RuleEngineAgency?.['Referral_Code'] || translations.commonMsg?.loading} className="form-label"></label>
                                                    {
                                                        errors && errors.referral_code
                                                        ?
                                                        <span className="error-txt">{errors.referral_code}</span>
                                                        :
                                                        ''
                                                    }
                                                </div>
                                            </fieldset>
                                        </div>
                                        <div className="row agency_basic_detail">
                                            <div className="col-md-12">
                                                <h2 className="agency-basic-detail">{translations.RuleEngineAgency?.['Personal_Details'] || translations.commonMsg?.loading} </h2>
                                            </div>
                                            <fieldset className="col-md-3">
                                                <div className="material">
                                                    <InputField
                                                        inputProps={{
                                                            id: "ktp_id",
                                                            name: "personalDetails.ktp_id",
                                                            className: "form-input",
                                                            type: "text",
                                                            value: selectedInput.personalDetails.ktp_id,
                                                            maxLength: "16",
                                                            disabled: disableField,
                                                        }}
                                                        onChange= {handleChange}
                                                    />
                                                    <label data-label={translations.RuleEngineAgency?.['KTP_ID']+' *' || translations.commonMsg?.loading} className="form-label"></label>
                                                    {
                                                        errors && errors.ktp_id
                                                        ?
                                                        <span className="error-txt">{errors.ktp_id}</span>
                                                        :
                                                        ''
                                                    }
                                                </div>
                                            </fieldset>
                                            <fieldset className="col-md-3">
                                                <div className="material">
                                                    <InputField
                                                        inputProps={{
                                                            id: "npwp_no",
                                                            name: "personalDetails.npwp_no",
                                                            className: "form-input",
                                                            type: "text",
                                                            value: selectedInput.personalDetails.npwp_no,
                                                            disabled: disableField,

                                                        }}
                                                        onChange= {handleChange}
                                                    />
                                                    <label data-label={translations.RuleEngineAgency?.['NPWP_No'] || translations.commonMsg?.loading} className="form-label"></label>
                                                    {
                                                        errors && errors.npwp_no
                                                        ?
                                                        <span className="error-txt">{errors.npwp_no}</span>
                                                        :
                                                        ''
                                                    }
                                                </div>
                                            </fieldset>
                                            <ReactSelect
                                                options={martialStatusOptions ?? []}
                                                value={martialStatusOptions?.find((option:any) => option.value === selectedInput.personalDetails.marital_status)}
                                                placeholder={translations.RuleEngineAgency?.['Martial_Status'] || translations.commonMsg?.loading}
                                                isDisabled={disableField}
                                                fieldSetClassName="col-md-3"
                                                handleChange={(selectedOption: any) => handleDropdownChange(selectedOption, "personalDetails.marital_status")}
                                                errorField={errors.marital_status}
                                            />
                                            <fieldset className="from-group col-md-3">
                                                <div className="material">
                                                    <label>{translations.Insurance?.['Gender'] || translations.commonMsg?.loading} *</label>
                                                    <div className="radio-type-txt radio-btn gender-radio">
                                                        <div className="custom-control custom-checkbox">
                                                            <input id="Individual" type="radio"
                                                                className="custom-control-input "
                                                                name="personalDetails.gender"
                                                                value={1}
                                                                checked={Number(selectedInput.personalDetails.gender) === 1}
                                                                disabled={disableField}
                                                                onChange={handleChange}
                                                            />
                                                            <label className="custom-control-label">{translations.RuleEngineAgency?.['Male'] || translations.commonMsg?.loading} </label>
                                                        </div>
                                                        <div className="custom-control custom-checkbox">
                                                            <input id="Individual" type="radio"
                                                                className="custom-control-input "
                                                                name="personalDetails.gender"
                                                                value={2}
                                                                checked={Number(selectedInput.personalDetails.gender) === 2}
                                                                disabled={disableField}
                                                                onChange={handleChange}
                                                            />
                                                            <label className="custom-control-label">{translations.RuleEngineAgency?.['Female'] || translations.commonMsg?.loading}</label>
                                                        </div>
                                                        {
                                                            errors && errors.gender
                                                                ?
                                                                <span className="error-txt">{errors.gender}</span>
                                                                :
                                                                ''
                                                        }
                                                    </div>

                                                </div>
                                            </fieldset>
                                            <fieldset className='multi-datepicker col-md-3'>
                                                <div className="datepicker">
                                                    <DatePicker
                                                        value={selectedInput.personalDetails.dob}
                                                        onChange={(date: any) => handleDateChange(date)}
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        placeholderText={translations.RuleEngineAgency?.['DOB'] || translations.commonMsg?.loading}
                                                        maxDate={new Date()} 
                                                    />
                                                    <label title={translations.RuleEngineAgency?.['DOB'] || translations.commonMsg?.loading} data-label={translations.RuleEngineAgency?.['DOB'] || translations.commonMsg?.loading} className={`form-label datepick-heading`}></label>
                                                    {
                                                        errors && errors.dob
                                                        ?
                                                        <span className="error-txt error-docs-upload">{errors.dob}</span>
                                                        :
                                                        ''
                                                    }
                                                </div>
                                            </fieldset>
                                            <ReactSelect
                                                options={cityList ?? []}
                                                value={cityList?.find((option:any) => option.value === selectedInput.personalDetails.city_of_birth)}
                                                placeholder={translations.RuleEngineAgency?.['City_Birth'] || translations.commonMsg?.loading}
                                                isDisabled={disableField}
                                                fieldSetClassName="col-md-3"
                                                handleChange={(selectedOption: any) => handleDropdownChange(selectedOption,"personalDetails.city_of_birth")}
                                                errorField={errors.city_of_birth}
                                            />
                                        </div>
                                        <div className="row agency_basic_detail">
                                            <div className="col-md-12">
                                                <h2 className="agency-basic-detail">KTP Address Details</h2>
                                            </div>
                                            <fieldset className="col-md-3">
                                                <div className="material">
                                                    <InputField
                                                        inputProps={{
                                                            id: "housing",
                                                            name: "ktpAddressDetails.housing",
                                                            className: "form-input",
                                                            type: "text",
                                                            value: selectedInput.ktpAddressDetails.housing,
                                                            disabled: disableField,
                                                        }}
                                                        onChange= {handleChange}
                                                    />
                                                    <label data-label={translations.RuleEngineAgency?.['Housing']+' *' || translations.commonMsg?.loading} className="form-label"></label>
                                                    {
                                                        errors && errors.housing
                                                        ?
                                                        <span className="error-txt">{errors.housing}</span>
                                                        :
                                                        ''
                                                    }
                                                </div>
                                            </fieldset>
                                            <fieldset className="col-md-3">
                                                <div className="material">
                                                    <InputField
                                                        inputProps={{
                                                            id: "rt",
                                                            name: "ktpAddressDetails.rt",
                                                            className: "form-input",
                                                            type: "text",
                                                            value: selectedInput.ktpAddressDetails.rt,
                                                            disabled: disableField,
                                                        }}
                                                        onChange= {handleChange}
                                                    />
                                                    <label data-label={translations.RuleEngineAgency?.['RT'] + ' *' || translations.commonMsg?.loading} className="form-label"></label>
                                                    {
                                                        errors && errors.rt
                                                        ?
                                                        <span className="error-txt">{errors.rt}</span>
                                                        :
                                                        ''
                                                    }
                                                </div>
                                            </fieldset>
                                            <fieldset className="col-md-3">
                                                <div className="material">
                                                    <InputField
                                                        inputProps={{
                                                            id: "rw",
                                                            name: "ktpAddressDetails.rw",
                                                            className: "form-input",
                                                            type: "text",
                                                            value: selectedInput.ktpAddressDetails.rw,
                                                            disabled: disableField,
                                                        }}
                                                        onChange= {handleChange}
                                                    />
                                                    <label data-label={translations.RuleEngineAgency?.['RW'] + ' *'|| translations.commonMsg?.loading} className="form-label"></label>
                                                    {
                                                        errors && errors.rw
                                                        ?
                                                        <span className="error-txt">{errors.rw}</span>
                                                        :
                                                        ''
                                                    }
                                                </div>
                                            </fieldset>
                                            <ReactSelect
                                                options={cityList ?? []}
                                                value={cityList?.find((option:any) => option.value === selectedInput.ktpAddressDetails.city)}
                                                placeholder={translations.RuleEngineAgency?.['City']+' *' || translations.commonMsg?.loading}
                                                isDisabled={disableField}
                                                fieldSetClassName="col-md-3"
                                                handleChange={(selectedOption: any) => handleDropdownChange(selectedOption, "ktpAddressDetails.city")}
                                                errorField={errors.city}
                                            />
                                             <ReactSelect
                                                options={districts ?? []}
                                                value={districts?.find((option:any) => option.value === selectedInput.ktpAddressDetails.district)}
                                                placeholder={translations.RuleEngineAgency?.['District']+' *' || translations.commonMsg?.loading}
                                                isDisabled={disableField}
                                                fieldSetClassName="col-md-3"
                                                handleChange={(selectedOption: any) => handleDropdownChange(selectedOption, "ktpAddressDetails.district")}
                                                errorField={errors.district}
                                            />

                                            <fieldset className="col-md-3">
                                                <div className="material">
                                                    <InputField
                                                        inputProps={{
                                                            id: "sub_district",
                                                            name: "ktpAddressDetails.sub_district",
                                                            className: "form-input",
                                                            type: "text",
                                                            value: selectedInput.ktpAddressDetails.sub_district,
                                                            disabled: disableField,
                                                        }}
                                                        onChange= {handleChange}
                                                    />
                                                    <label data-label={translations.RuleEngineAgency?.['Sub_District']+' *' || translations.commonMsg?.loading} className="form-label"></label>
                                                    {
                                                        errors && errors.sub_district
                                                        ?
                                                        <span className="error-txt">{errors.sub_district}</span>
                                                        :
                                                        ''
                                                    }
                                                </div>
                                            </fieldset>
                                        </div>
                                        <div className="row agency_basic_detail">
                                            <div className="col-md-12">
                                                <h2 className="agency-basic-detail">Bank Details</h2>
                                            </div>
                                            <ReactSelect
                                                options={agencyBanksLists ?? []}
                                                value={agencyBanksLists?.find((option:any) => option.value === selectedInput.bankDetails.bank_name)}
                                                placeholder={translations.RuleEngineAgency?.['Bank_Name']+' *' || translations.commonMsg?.loading} 
                                                isDisabled={disableField}
                                                fieldSetClassName="col-md-3"
                                                handleChange={(selectedOption: any) => handleDropdownChange(selectedOption, "bankDetails.bank_name")}
                                                errorField={errors.bank_name}
                                            />
                                             <fieldset className="col-md-3">
                                                <div className="material">
                                                    <InputField
                                                        inputProps={{
                                                            id: "branch_name",
                                                            name: "bankDetails.branch_name",
                                                            className: "form-input",
                                                            type: "text",
                                                            value: selectedInput.bankDetails.branch_name,
                                                            disabled: disableField,
                                                        }}
                                                        onChange= {handleChange}
                                                    />
                                                    <label data-label={translations.RuleEngineAgency?.['Branch_Name'] || translations.commonMsg?.loading} className="form-label"></label>
                                                    {
                                                        errors && errors.branch_name
                                                        ?
                                                        <span className="error-txt">{errors.branch_name}</span>
                                                        :
                                                        ''
                                                    }
                                                </div>
                                            </fieldset>
                                            <fieldset className="col-md-3">
                                                <div className="material">
                                                    <InputField
                                                        inputProps={{
                                                            id: "back_account_no",
                                                            name: "bankDetails.account_no",
                                                            className: "form-input",
                                                            type: "text",
                                                            value: selectedInput.bankDetails.account_no,
                                                            disabled: disableField,
                                                        }}
                                                        onChange= {handleChange}
                                                    />
                                                    <label data-label={translations.RuleEngineAgency?.['Account_Number']+' *' || translations.commonMsg?.loading} className="form-label"></label>
                                                    {
                                                        errors && errors.account_no
                                                        ?
                                                        <span className="error-txt">{errors.account_no}</span>
                                                        :
                                                        ''
                                                    }
                                                </div>
                                            </fieldset>
                                            <fieldset className="col-md-3">
                                                <div className="material">
                                                    <InputField
                                                        inputProps={{
                                                            id: "beneficiry_name",
                                                            name: "bankDetails.beneficiary_name",
                                                            className: "form-input",
                                                            type: "text",
                                                            value: selectedInput.bankDetails.beneficiary_name,
                                                            disabled: disableField,
                                                        }}
                                                        onChange= {handleChange}
                                                    />
                                                    <label data-label={translations.RuleEngineAgency?.['Beneficiary_Name']+' *' || translations.commonMsg?.loading} className="form-label"></label>
                                                    {
                                                        errors && errors.beneficiary_name
                                                        ?
                                                        <span className="error-txt">{errors.beneficiary_name}</span>
                                                        :
                                                        ''
                                                    }
                                                </div>
                                            </fieldset>
                                        </div>
                                        <div className="row">
                                            <InsIdUploadDocuments
                                                heading={translations.RuleEngineAgency?.['Upload_Documents'] || translations.commonMsg?.loading}
                                                documents={bankDocuments}
                                                initialDocs={bankDocs}
                                                onDocumentUpload={(uploadedDocument:any) => handleDocumentUpload(uploadedDocument, true)}
                                                onDocumentRemove={(label: string) => handleDocumentRemove(label, true)}
                                                errors={errors}
                                            />
                                        </div>
                                        <div className="row agency_basic_detail">
                                            <div className="col-md-12">
                                                <h2 className="agency-basic-detail">{translations.RuleEngineAgency?.['Role_Details'] || translations.commonMsg?.loading} </h2>
                                            </div>
                                            <ReactSelect
                                                options={ roleList ?? []}
                                                value={roleList?.find((option:any) => option.value === selectedInput.roleDetails.user_role)}
                                                placeholder={translations.RuleEngineAgency?.['User_Role']+' *' || translations.commonMsg?.loading} 
                                                isDisabled={disableField}
                                                fieldSetClassName="col-md-3"
                                                handleChange={(selectedOption: any) => handleDropdownChange(selectedOption, "roleDetails.user_role")}
                                                menuPlacement="top"
                                                menuPortalTarget={document.body}
                                                errorField={errors.user_role}
                                            />
                                            {selectedInput.roleDetails.user_role !== VP_ID && (
                                                <ReactSelect
                                                    options={ reportingToRole ?? []}
                                                    value={reportingToRole?.find((option:any) => option.value === selectedInput.roleDetails.reporting_to_role)}
                                                    placeholder={translations.RuleEngineAgency?.['Role_Details']+' *' || translations.commonMsg?.loading}
                                                    // isDisabled={disableField}
                                                    isDisabled={true}
                                                    fieldSetClassName="col-md-3"
                                                    handleChange={(selectedOption: any) => handleDropdownChange(selectedOption, "roleDetails.reporting_to_role")}
                                                    errorField={errors.reporting_to_role}
                                                />
                                            )}
                                            {selectedInput.roleDetails.user_role !== VP_ID && (
                                            <ReactSelect
                                                options={reportingTo ?? []}
                                                value={reportingTo?.find((option: any) => option.value === selectedInput.roleDetails.reporting_to)}
                                                placeholder={translations.RuleEngine?.['Reporting_to']+' *' || translations.commonMsg?.loading}
                                                isDisabled={disableField}
                                                fieldSetClassName="col-md-3"
                                                handleChange={(selectedOption: any) => handleDropdownChange(selectedOption, "roleDetails.reporting_to")}
                                                menuPlacement="top"
                                                menuPortalTarget={document.body}
                                                errorField={errors.reporting_to}
                                            />
                                            )}

                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {showConfirmation === false ? ("") : (
                <ConfirmPopUp
                    confirmNo={confirmNo}
                    confirmYes={confirmYes}
                    message={confirmationMessage} />
            )}
            {
                showRejectReason && 
                <RejectReasonPopup confirmNo={rejectNo} confirmYes={rejectYes} reason={rejectReason}></RejectReasonPopup>
            }
        </React.Fragment>
    )
}

export default AddEditInsuranceIdAgency;